module.exports = __webpack_public_path__ + "media/website.650af923.mp4";